const baseUrl = '/inunitamenities';
export const inUnitAmenitiesRoutes = {
  baseUrl: "".concat(baseUrl)
};